import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TeacherAnalyticsStatisticsResponse } from '@edtech-ui/core/models/admin-panel/admin-analytics';
import { SubmitAdminQuerypayload, SubmitAdminQueryResponse } from '@edtech-ui/core/models/admin-panel/admin-query';
import { DeleteUserByIdResponse } from '@edtech-ui/core/models/admin-panel/batch-management/delete-user-by-id';
import { AdminDashboardInfoResponse } from '@edtech-ui/core/models/dashboard/admin-dashboard-data';
import { TeacherOnBoardInvitationDataResponse } from '@edtech-ui/core/models/interfaces/student-dashboard/get-onBoard-invite';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AdminService {

	apiUrl = environment.adminApiUrl;

	constructor(private http: HttpClient) { }

	getAdminDashboard(): Observable<AdminDashboardInfoResponse> {
		return this.http.get<AdminDashboardInfoResponse>(`${this.apiUrl}${environment.superAdminDashboardEndpoints.superAdminDashboard}`);
	}

	getAdminTeacherInvite():Observable<TeacherOnBoardInvitationDataResponse>{
		return this.http.get<TeacherOnBoardInvitationDataResponse>(`${this.apiUrl}${environment.superAdminDashboardEndpoints.adminTeacherInvite}`);
	}

	deleteUserById(userId:string):Observable<DeleteUserByIdResponse>{
		return this.http.delete<DeleteUserByIdResponse>(`${this.apiUrl}/deleteUser/${userId}`);
	}

	postSubmitAdminQuery(payload: SubmitAdminQuerypayload): Observable<SubmitAdminQueryResponse> {
		return this.http.post<SubmitAdminQueryResponse>(`${this.apiUrl}/submitQuery`, payload);
	}

	getAllStatisticsTeachers(): Observable<TeacherAnalyticsStatisticsResponse> {
		return this.http.get<TeacherAnalyticsStatisticsResponse>(`${this.apiUrl}/statistics`);
	}

}